import {translate} from "../../utils";

export default class IPItem extends PIXI.Container {

    get data() {
        return this._data;
    }

    get logo() {
        return this._logo;
    }

    constructor(data) {
        super();
        
        this._image = new PIXI.Sprite(P3.assets.texture(data.carousel_image));
        this._image.anchor.set(0.5);
        this.addChild(this._image);

        this._logo = new PIXI.Sprite(P3.assets.texture("game_logo"));
        this._logo.anchor.set(0.5, 1);
        this._logo.position.set(0, -this._image.height / 2 + 40);
        this._logo.scale.set(0.9);
        this._logo.visible = false;
        this.addChild(this._logo);

        this._data = data;
    }
}